
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_24243_5034)","stroke":"#E6E7E9","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12.797 12.373a2.023 2.023 0 01-1.611 0L1.414 7.848a.96.96 0 010-1.715l9.772-4.56a2.023 2.023 0 011.611 0L22.57 6.1a.96.96 0 010 1.714l-9.772 4.56zM23.137 13.145L12.68 17.962a1.715 1.715 0 01-1.423 0L.852 13.145M23.137 18.716L12.68 23.533a1.714 1.714 0 01-1.423 0L.852 18.716"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_24243_5034"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .545)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    